import React from 'react';
import './styles.scss';
import { Spinner } from 'react-bootstrap';
import InfoIcon from '@mui/icons-material/Info';
import Button from '../../../components/molecules/buttons';
import { Print, Upload } from '../../../components/atoms/icons';
import Forms from '../../../components/molecules/forms';
import RenderTableWarehouse from './RenderTableWarehouse';
import useWarehouse from './hooks';
import AddAisle from './aisle';
import LandingHeader from '../../../components/layout/header/landing';

function Warehouse() {
  const {
    warehouse, search, selectedWarehouse, aisle, navigation,
  } = useWarehouse();
  return (
    <div className="py-4">
      <LandingHeader title="Warehouse" />
      <div className="px-4 px-xl-5">
        <div className="row">
          <div className="mb-4 col-xl-3 col-md-4">
            <div className="d-flex align-items-center">
              <Forms.ReactSelect.Default
                id="formWarehouse"
                placeholder="Choose Warehouse"
                options={warehouse.list}
                disabled={warehouse.load}
                value={selectedWarehouse.current}
                onChange={(e) => {
                  if (e) {
                    selectedWarehouse.setCurrent(e);
                    search.setCurrent('');
                  }
                }}
                isSearchable={false}
                className="me-2"
              />
              <InfoIcon
                sx={selectedWarehouse.current ? {
                  color: 'black', width: 30, height: 30,
                } : { display: 'none' }}
                onClick={navigation.detail}
                type="button"
              />
            </div>
          </div>
          <div className="row pe-0 mb-4 offset-xl-4 col-xl-5 offset-lg-2 col-lg-6 offset-md-0 col-md-8">
            <div className="col-1" style={{ paddingTop: 7 }}>
              <Print width={30} />
            </div>
            <div className="col-1" style={{ paddingTop: 8 }}>
              <Upload />
            </div>
            <div className="col-5 pe-0">
              <Button.Default
                id="btn-addWarehouse"
                outline
                label="Add Warehouse"
                onClick={navigation.add}
              />
            </div>
            <div className="col-5 pe-0">
              <AddAisle
                warehouseId={selectedWarehouse.current?.value}
                isUpdate={false}
                refetch={aisle.refetch}
                aisleName={undefined}
              />
            </div>
          </div>
        </div>
        <div style={{ height: '42px' }} className="mb-4">
          <Forms.Search
            value={search.current}
            onChange={(e) => search.setCurrent(e.target.value)}
          />
        </div>
        <div>
          {(() => {
            if (aisle.load) {
              return (
                <div className="flexible-center">
                  <Spinner animation="border" />
                </div>
              );
            }
            if (aisle.list && aisle.list.length) {
              return (
                <div className="row">
                  {aisle.list.map((data, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={i} className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4">
                      <RenderTableWarehouse
                        data={data}
                        refetch={aisle.refetch}
                        warehouseId={selectedWarehouse.current?.value}
                        aisleName={data.name}
                        searchValue={search.current ?? ''}
                      />
                    </div>
                  ))}
                </div>
              );
            }
            return (
              <div className="text-center">Data Not Found</div>
            );
          })()}
        </div>
      </div>
    </div>
  );
}

export default Warehouse;
